import { Rook } from './Rook';
import { Bishop } from './Bishop';

export class Queen {
  static getMoves(position, color, gameState) {
    const rookMoves = Rook.getMoves(position, color, gameState);
    const bishopMoves = Bishop.getMoves(position, color, gameState);
    
    return [...rookMoves, ...bishopMoves];
  }
}